/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateOrganizationApiKeyResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createListOrganizationApiKeysResponseFromDiscriminatorValue, serializeCreateOrganizationApiKeyRequest, serializeCreateOrganizationApiKeyResponse, type CreateOrganizationApiKeyRequest, type CreateOrganizationApiKeyResponse, type ErrorResponse, type InternalErrorResponse, type ListOrganizationApiKeysResponse } from '../../../models/index.js';
// @ts-ignore
import { type WithKeyItemRequestBuilder, WithKeyItemRequestBuilderNavigationMetadata, WithKeyItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/api-keys
 */
export interface ApiKeysRequestBuilder extends BaseRequestBuilder<ApiKeysRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.organizations.apiKeys.item collection
     * @param keyId Unique identifier of the item
     * @returns {WithKeyItemRequestBuilder}
     */
     byKeyId(keyId: string) : WithKeyItemRequestBuilder;
    /**
     * Returns each key the organization can still use, with its access, status and the leading and trailing characters of its value. Revoked keys are excluded — they are retained as an audit record but can never be used or acted on again. Key values themselves are never returned; they are readable only in the response that created or rotated them.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListOrganizationApiKeysResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 401 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ListOrganizationApiKeysResponse | undefined>;
    /**
     * Issues an API key granting the requested access: admin for general integrations, storefront for the buyer-facing site, or sql-connector for the on-premises connector. The key value is returned once and cannot be retrieved again. Storefront keys are only issued to organizations whose subscription includes the storefront, and an organization may hold at most two of them at a time.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateOrganizationApiKeyResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 401 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateOrganizationApiKeyRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateOrganizationApiKeyResponse | undefined>;
    /**
     * Returns each key the organization can still use, with its access, status and the leading and trailing characters of its value. Revoked keys are excluded — they are retained as an audit record but can never be used or acted on again. Key values themselves are never returned; they are readable only in the response that created or rotated them.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Issues an API key granting the requested access: admin for general integrations, storefront for the buyer-facing site, or sql-connector for the on-premises connector. The key value is returned once and cannot be retrieved again. Storefront keys are only issued to organizations whose subscription includes the storefront, and an organization may hold at most two of them at a time.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateOrganizationApiKeyRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ApiKeysRequestBuilderUriTemplate = "{+baseurl}/api/organizations/api-keys";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ApiKeysRequestBuilderNavigationMetadata: Record<Exclude<keyof ApiKeysRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byKeyId: {
        requestsMetadata: WithKeyItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithKeyItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["keyId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ApiKeysRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ApiKeysRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createListOrganizationApiKeysResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: ApiKeysRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateOrganizationApiKeyResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateOrganizationApiKeyRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
